import styled from "styled-components";

// Shared shell for the add-user success screen and its inert list backdrop.
export const Page = styled.main`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`;

export const BackgroundPage = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  user-select: none;
`;
